import { computed, type Ref } from 'vue';

type DeviceRow = {
  name?: string;
  serial?: string;
  serial_number?: string;
  imei?: string;
};

export function useShipmentFormDeviceLookup(options: {
  devicesMap: Ref<Map<number, DeviceRow>>;
  deviceIds: Ref<readonly number[]>;
}) {
  function deviceLabelForId(id: number): string {
    const d = options.devicesMap.value.get(id);
    return (typeof d?.name === 'string' && d.name.trim()) || `Device #${id}`;
  }

  function assignedDeviceForId(id: number) {
    const d = options.devicesMap.value.get(id);
    const name = deviceLabelForId(id);
    const serial = d?.serial ?? d?.serial_number ?? null;
    const imei = d?.imei ?? null;
    return { id, name, serial, imei };
  }

  const assignedDevices = computed(() =>
    [
      ...new Set(options.deviceIds.value.filter((id) => id != null && id > 0)),
    ].map((id) => assignedDeviceForId(id)),
  );

  return {
    deviceLabelForId,
    assignedDevices,
  };
}
